/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommExchangeItemsDialog extends _Ext.ItemEditorDialog<ECommExchangeItemsRow> {
        protected getFormKey() { return ECommExchangeItemsForm.formKey; } 
        protected getLocalTextPrefix() { return ECommExchangeItemsRow.localTextPrefix; } 
        protected getDeletePermission() { return ECommExchangeItemsRow.deletePermission; }
        protected getInsertPermission() { return ECommExchangeItemsRow.insertPermission; }
        protected getUpdatePermission() { return ECommExchangeItemsRow.updatePermission; }

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        protected form = new ECommExchangeItemsForm(this.idPrefix);
         
        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            //q.initLaborEditor(this, this.form.LaborDetails, Config);

            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);

            // **** Assign Values to BOM and Labor Editor ****
            // this will be used to calculate Rate for RM and Labor while adding new item.
            this.form.BOMDetails.RateListId = this.RateListId;
            //this.form.LaborDetails.LaborListId = this.LaborListId;
            //this.form.LaborDetails.LaborMarkup = this.LaborMarkup;
            var itemtype = 0;
            this.form.ProductTypeId.changeSelect2(e => {
                itemtype = OMS.ProductTypeRow.getLookup().itemById[this.form.ProductTypeId.value].ItemTypeId;

                if (itemtype == 101) {

                    this.form.ItemTypeId.value = itemtype;
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                    this.SetFields(true);
                    this.form.CalcOnId.value = "3";
                    this.form.CalcUnitId.value = "6";
                    Purchase.PurchaseMasterService.GetLineNo({}, response => this.newLineNo = response.Line_No, {
                        async: false
                    });
                    this.form.Line_No.value = this.newLineNo.toString();
                } else if (itemtype == 104) {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    this.form.ItemTypeId.value = itemtype;
                    this.form.CalcOnId.value = "4";
                    this.SetFields(false);
                    this.Setfields();

                } 

                //this.form.ProductId.cascadeField="ItemTypeId";
                //this.form.ProductId.cascadeValue=this.form.ItemTypeId.value;
            });
            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                if (itemtype == 104) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 3) {
                        this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });
            // **** On Weight Change Event **** 
            this.form.Weight.changeSelect2(e => {
                if (itemtype == 104) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    //Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                        this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                        this.form.GrossAmount.value = this.form.NetAmount.value;
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                }
            });
            this.form.UnitRate.changeSelect2(e => {
                if (parseInt(this.form.CalcOnId.value) == 3) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
                else if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
            });
            this.form.CalcOnId.changeSelect2(e => {
                if (itemtype == 104) {
                    var weight = parseFloat(this.form.Pieces.value.toString());
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                    if (parseInt(this.form.CalcOnId.value) == 4 || parseInt(this.form.CalcOnId.value) == 5) {
                        this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    } else {
                        var pieces = parseInt(this.form.Pieces.value.toString());
                        if (parseInt(this.form.CalcOnId.value) == 3) {
                            this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                        }
                    }
                }
                else {
                    Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
                }
            });
            // **** On NetAmount Change Event **** 
            this.form.NetAmount.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });

            // **** On Wastage % Change Event **** 
            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            this.form.HasBom.changeSelect2(e => {
                if (this.form.HasBom.value) {
                    q.hideField(this.form.KaratId)
                    q.hideField(this.form.Purity)
                }
                else {
                    q.showAndSetRequiredField(this.form.KaratId)
                    q.showAndSetRequiredField(this.form.Purity)
                    q.showAndSetRequiredField(this.form.MetalId)
                }

            })
            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                min = purity.MinPurity;
                max = purity.MaxPurity;
                std = purity.StdPurity;
                this.form.Purity.value = std;
            });
            this.form.Purity.change(e => {
                var current = this.form.Purity.value;
                if (current < min || current > max) {
                    Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                    this.form.Purity.value = std;
                }
            });


            //*** BOM row add Edit Delete Event ****
            //Used to Update Amount weight and pieces from BOM to item
            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {

                this.CalculateTotals()
            });
             
            // **** On Labor Rate Change Event **** 
            this.form.UnitLabour.changeSelect2(e => {
                this.form.NetAmount.value = parseFloat(this.form.UnitRate.value.toString()) + parseFloat(this.form.UnitLabour.value.toString());
                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });

            this.form.ProductCode.changeSelect2(e => {
                if (this.form.ProductCode.value != null) {
                    try {

                        let PrdId = 0;
                        var equalFilter = { "ProductCode": this.form.ProductCode.value.toUpperCase() };

                        OMS.ProductMasterService.List({ EqualityFilter: equalFilter, Take: 1 },
                            response => {
                                if (response.Entities.length > 0)
                                    PrdId = response.Entities[0].ProductId;
                            }, {
                            async: false
                        }
                        );

                        if (PrdId > 0) {
                            Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                            this.form.ProductCode.value = "";
                            this.form.ProductCode.element.focus();
                            return;
                        }
                        else {
                            this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                        }

                    }
                    catch (undefined) {

                    }
                }
            });

        }
        calculateAmountTax() {
            if (this.form.ItemTypeId.value != undefined) {
                if (this.form.ItemTypeId.value.toString() == "101") {

                    var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
                    for (var k of this.form.BOMDetails.getItems()) {

                        if (k.ItemTypeId == 104) {
                            Wt += k.Weight;
                        }
                        if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                            cts += k.Weight;
                            diapcs += k.Pieces
                        }
                        if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                            gms += k.Weight;
                            clrpcs += k.Pieces;
                        }

                        rate += k.BomAmount;

                    }
                    this.form.NetWeight.value = Wt;
                    this.form.OtherPieces.value = othrpcs;
                    this.form.StonePieces.value = clrpcs;
                    this.form.StoneWeight.value = gms;
                    this.form.DiamondPieces.value = diapcs;
                    this.form.DiamondWeight.value = cts;
                    this.form.Weight.value = Wt + gms + (cts / 5);
                    this.form.UnitRate.value = rate;
                    this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;

                    if (this.form.Pieces.value != null) {
                        var pieces = parseInt(this.form.Pieces.value.toString());
                        var netamount = parseFloat(this.form.NetAmount.value.toString());
                        this.form.GrossAmount.value = (pieces * netamount);
                    }
                    if (!this.HasBom && this.entity.ItemTypeId == 101) {
                        this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                        this.form.NetWeight.value = this.entity.NetWeight;
                        this.form.UnitRate.value = this.entity.UnitRate;
                        this.form.NetAmount.value = this.entity.UnitRate * this.entity.Weight;
                        this.form.GrossAmount.value = this.entity.UnitRate * this.entity.Weight;
                    }

                }
            }
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.ItemTypeId.value != undefined) {
                if (this.form.ItemTypeId.value.toString() == "101") {
                    this.SetFields(true)

                } else {
                    this.SetFields(false)
                    this.Setfields();
                }
            } else {
                this.SetFields(false)
                this.Setfields();
            }
             
        }


        CalculateTotals() {
            if (this.form.HasBom.value) {
                var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
                var labrate = 0.00; var wstper = 0; var wstwt = 0;
                for (var k of this.form.BOMDetails.getItems()) {

                    if (k.ItemTypeId == 104) {
                        Wt += k.Weight;
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                        cts += k.Weight;
                        diapcs += k.Pieces
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                        gms += k.Weight;
                        clrpcs += k.Pieces;
                    }
                    rate += k.BomAmount;
                }

                var LAmount = 0;
                var Wst = 0; 
                this.form.UnitLabour.value = LAmount;
                this.form.WstPer.value = Wst;
                this.form.WstWt.value = this.form.Weight.value * Wst;

                this.form.NetWeight.value = Wt;
                this.form.OtherPieces.value = othrpcs || 0;
                this.form.StonePieces.value = clrpcs || 0;
                this.form.StoneWeight.value = gms;
                this.form.DiamondPieces.value = diapcs || 0;
                this.form.DiamondWeight.value = cts || 0;
                this.form.OtherWeight.value = 0;

                if (cts > 0)
                    this.form.Weight.value = Wt + gms + (cts / 5);
                else
                    this.form.Weight.value = Wt + gms;
                this.form.UnitRate.value = rate / this.form.Pieces.value;
                this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;

                if (this.form.Pieces.value != null) {
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                }
            }
            else if (!this.form.HasBom.value && this.entity.ItemTypeId == 101) {
                this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                this.form.NetWeight.value = this.entity.NetWeight;
                this.form.UnitRate.value = this.entity.UnitRate;
                var LAmount = 0;
                var Wst = 0; 
                this.form.UnitLabour.value = LAmount;

                this.form.NetAmount.value = (this.entity.UnitRate * this.entity.Weight) + this.form.UnitLabour.value;
                this.form.GrossAmount.value = this.entity.UnitRate * this.entity.Weight;

            } 
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.entityId != undefined) {
                if (!this.form.HasBom.value) {
                    this.HasBom = false;
                    q.hideEditorCategory(this.form.BOMDetails);
                    q.hideField(this.form.BOMDetails);
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                }
            }
        }

        getItem() {
            return this.getSaveEntity();
        }


        private SetFields(x: boolean) {
            this.form.BOMDetails.getGridField().toggle(x);
            this.form.BrandId.getGridField().toggle(x);
            this.form.CollectionId.getGridField().toggle(x);
            this.form.SuperTypeId.getGridField().toggle(x);
            this.form.ProductSizeId.getGridField().toggle(x);
            this.form.UnitLabour.getGridField().toggle(x);
            this.form.NetWeight.getGridField().toggle(x);
            this.form.DiamondPieces.getGridField().toggle(x);
            this.form.DiamondWeight.getGridField().toggle(x);
            this.form.StonePieces.getGridField().toggle(x);
            this.form.StoneWeight.getGridField().toggle(x);
            this.form.OtherWeight.getGridField().toggle(x);
            this.form.OtherPieces.getGridField().toggle(x);
            this.form.WstPer.getGridField().toggle(x);
            this.form.WstWt.getGridField().toggle(x);
            this.form.ProductId.getGridField().toggle(!x);
            this.form.Line_No.getGridField().toggle(x);
            //this.form.SKU.getGridField().toggle(x);
            this.form.CategoryId.getGridField().toggle(x);
            //this.form.RefVoucherId.getGridField().toggle(x);
            q.hideEditorTab(this.form.BOMDetails, !x);
            q.hideEditorTab(this.form.ImageName, !x);
        }
        private Setfields() {

            if (this.form.ProductTypeId.value == "5" || this.form.ProductTypeId.value == "6" || this.form.ProductTypeId.value == "7") {
                this.form.KaratId.getGridField().toggle(true);
                this.form.MetalColorId.getGridField().toggle(true);
                this.form.Purity.getGridField().toggle(true);

                this.form.SubCategoryId.getGridField().toggle(false);
                this.form.ShapeId.getGridField().toggle(false);
                this.form.QualityId.getGridField().toggle(false);
                this.form.StoneColorId.getGridField().toggle(false);
                this.form.StoneSizeId.getGridField().toggle(false);

                // Set Required True
                Serenity.EditorUtils.setRequired(this.form.KaratId, true);
                Serenity.EditorUtils.setRequired(this.form.MetalColorId, true);
                Serenity.EditorUtils.setRequired(this.form.Purity, true);

                // Set Required false
                Serenity.EditorUtils.setRequired(this.form.SubCategoryId, false);
                Serenity.EditorUtils.setRequired(this.form.ShapeId, false);
                Serenity.EditorUtils.setRequired(this.form.QualityId, false);
                Serenity.EditorUtils.setRequired(this.form.StoneColorId, false);
                Serenity.EditorUtils.setRequired(this.form.StoneSizeId, false);


                if (this.form.ItemTypeId.value == 0)
                    this.form.ItemTypeId.value = 104;

                if (this.form.CategoryId.value.length == 0)
                    this.form.CategoryId.value = "123";

                if (this.form.ProductTypeId.value == "5")
                    this.form.SubCategoryId.value = "301";

                if (this.form.ProductTypeId.value == "6")
                    this.form.SubCategoryId.value = "302";

                if (this.form.ProductTypeId.value == "7")
                    this.form.SubCategoryId.value = "303";
            }

            if (this.form.ProductTypeId.value == "11" || this.form.ProductTypeId.value == "12" || this.form.ProductTypeId.value == "13") {
                this.form.SubCategoryId.getGridField().toggle(true);
                this.form.ShapeId.getGridField().toggle(true);
                this.form.QualityId.getGridField().toggle(true);
                this.form.StoneColorId.getGridField().toggle(true);
                this.form.StoneSizeId.getGridField().toggle(true);

                this.form.KaratId.getGridField().toggle(false);
                this.form.MetalColorId.getGridField().toggle(false);
                this.form.Purity.getGridField().toggle(false);

                //this.form.SubCategoryId.value = "0";


                //Set Required True
                Serenity.EditorUtils.setRequired(this.form.SubCategoryId, true);
                Serenity.EditorUtils.setRequired(this.form.ShapeId, true);
                Serenity.EditorUtils.setRequired(this.form.QualityId, true);
                Serenity.EditorUtils.setRequired(this.form.StoneColorId, true);
                Serenity.EditorUtils.setRequired(this.form.StoneSizeId, true);


                //Set Required false
                Serenity.EditorUtils.setRequired(this.form.KaratId, false);
                Serenity.EditorUtils.setRequired(this.form.MetalColorId, false);
                Serenity.EditorUtils.setRequired(this.form.Purity, false);

                if (this.form.ItemTypeId.value == 0)
                    this.form.ItemTypeId.value = 105;

                if (this.form.CategoryId.value.length == 0)
                    this.form.CategoryId.value = "124";
                this.form.SieveId.value = "131";

            }

        } 
    }
}